/**
 * Copyright © WarmHeart Intelligence Technology Group (Jiangsu) Co.,Ltd Company, Limited.
 * All Rights Reserved
 */
import url from "./conf";
import {post, postDownload, tokenPost} from "./ajax";

const shop = {
  /**
   *  AJAX-搜索门店（分页）
   *  @param keys
   *  @param page
   * @param success
   * @param fail
   * @param isLoadingExplicit
   * @param errorHandler
   */
  listShop(keys,page, success, fail, isLoadingExplicit, errorHandler) {
    post.bind(this)(
      url.LIST_SHOP,
      {
        keys: keys,
        pageIndex: page.pagination,
        pageSize: page.size,
      },
      success,
      fail,
      isLoadingExplicit,
      errorHandler
    );
  },
  /**
   *  AJAX-添加门店
   * @param info
   * @param success
   * @param fail
   * @param isLoadingExplicit
   * @param errorHandler
   */
  addShop(info, success, fail, isLoadingExplicit, errorHandler) {
    post.bind(this)(
      url.ADD_SHOP,
      {
        shopNum: info.shopNum,
        shopName: info.shopName,
        shopAddress: info.shopAddress,
        contactName: info.contactName,
        mobileNo: info.mobileNo,
        brandId: info.brandId,
      },
      success,
      fail,
      isLoadingExplicit,
      errorHandler
    );
  },
  /**
   *  AJAX-停用门店
   * @param id
   * @param flag true 停用 false 启用
   * @param success
   * @param fail
   * @param isLoadingExplicit
   * @param errorHandler
   */
  stopShop(id, flag, success, fail, isLoadingExplicit, errorHandler) {
    post.bind(this)(
      url.STOP_SHOP,
      {
        id: id,
        flag: flag,
      },
      success,
      fail,
      isLoadingExplicit,
      errorHandler
    );
  },
  /**
   *  AJAX-获取门店详情
   * @param id
   * @param success
   * @param fail
   * @param isLoadingExplicit
   * @param errorHandler
   */
  acquireShopDetail(id, success, fail, isLoadingExplicit, errorHandler) {
    post.bind(this)(
      url.ACQUIRE_SHOP_DETAIL,
      {
        id: id,
      },
      success,
      fail,
      isLoadingExplicit,
      errorHandler
    );
  },

  /**
   *  AJAX-修改门店
   * @param info
   * @param success
   * @param fail
   * @param isLoadingExplicit
   * @param errorHandler
   */
  modifyShop(info, success, fail, isLoadingExplicit, errorHandler) {
    post.bind(this)(
      url.MODIFY_SHOP,
      {
        shopNum: info.shopNum,
        shopName: info.shopName,
        shopAddress: info.shopAddress,
        contactName: info.contactName,
        mobileNo: info.mobileNo,
        isStop: info.isStop,
        brandId: info.brandId,
      },
      success,
      fail,
      isLoadingExplicit,
      errorHandler
    );
  },
  /**
   *  AJAX-添加供应商
   *  @param shopId
   *  @param supplierId
   * @param success
   * @param fail
   * @param isLoadingExplicit
   * @param errorHandler
   */
  addSupplier(shopId,supplierId,success, fail, isLoadingExplicit, errorHandler) {
    post.bind(this)(
      url.ADD_SUPPLIER_SHOP,
      {
        shopId: shopId,
        supplierId: supplierId,
      },
      success,
      fail,
      isLoadingExplicit,
      errorHandler
    );
  },
  /**
   *  AJAX-分页获取供应商列表
   *  @param shopId
   *  @param page
   * @param success
   * @param fail
   * @param isLoadingExplicit
   * @param errorHandler
   */
  listSupplier(shopId,page,success, fail, isLoadingExplicit, errorHandler) {
    post.bind(this)(
      url.LIST_SUPPLIER_SHOP,
      {
        shopId: shopId,
        pageIndex: page.pagination,
        pageSize: page.size,
      },
      success,
      fail,
      isLoadingExplicit,
      errorHandler
    );
  },
  /**
   *  AJAX-删除供应商
   *  @param shopId
   *  @param supplierId
   * @param success
   * @param fail
   * @param isLoadingExplicit
   * @param errorHandler
   */
  deleteSupplier(shopId,supplierId,success, fail, isLoadingExplicit, errorHandler) {
    post.bind(this)(
      url.DELETE_SUPPLIER_SHOP,
      {
        shopId: shopId,
        supplierId: supplierId,
      },
      success,
      fail,
      isLoadingExplicit,
      errorHandler
    );
  },
  /**
   *  AJAX-添加采购货品
   *  @param shopId
   *  @param supplierId
   *  @param materialId
   * @param success
   * @param fail
   * @param isLoadingExplicit
   * @param errorHandler
   */
  addPurchaseMaterial(shopId,materialId,supplierId,success, fail, isLoadingExplicit, errorHandler) {
    post.bind(this)(
      url.ADD_PURCHASE_MATERIAL_SHOP,
      {
        shopId: shopId,
        supplierId: supplierId,
        materialId: materialId,
      },
      success,
      fail,
      isLoadingExplicit,
      errorHandler
    );
  },

  /**
   *  AJAX-修改采购货品
   *  @param shopId
   *  @param supplierId
   *  @param materialId
   * @param success
   * @param fail
   * @param isLoadingExplicit
   * @param errorHandler
   */
  modifyPurchaseMaterial(shopId,materialId,supplierId,success, fail, isLoadingExplicit, errorHandler) {
    post.bind(this)(
      url.MODIFY_PURCHASE_MATERIAL_SHOP,
      {
        shopId: shopId,
        supplierId: supplierId,
        materialId: materialId,
      },
      success,
      fail,
      isLoadingExplicit,
      errorHandler
    );
  },
  /**
   *  AJAX-删除货品（采购、要货）
   *  @param shopId
   *  @param materialId
   * @param success
   * @param fail
   * @param isLoadingExplicit
   * @param errorHandler
   */
  deleteMaterial(shopId,materialId,success, fail, isLoadingExplicit, errorHandler) {
    post.bind(this)(
      url.DELETE_MATERIAL_SHOP,
      {
        shopId: shopId,
        materialId: materialId,
      },
      success,
      fail,
      isLoadingExplicit,
      errorHandler
    );
  },
  /**
   *  AJAX-添加要货货品
   *  @param unitPrice
   *  @param materialId
   *  @param shopId
   * @param success
   * @param fail
   * @param isLoadingExplicit
   * @param errorHandler
   */
  addRequireMaterial(shopId,materialId,unitPrice,success, fail, isLoadingExplicit, errorHandler) {
    post.bind(this)(
      url.ADD_REQUIRE_MATERIAL_SHOP,
      {
        unitPrice: unitPrice,
        materialId: materialId,
        shopId: shopId,
      },
      success,
      fail,
      isLoadingExplicit,
      errorHandler
    );
  },
  /**
   *  AJAX-分页获取采购货品列表
   *  @param shopId
   *  @param supplierId
   *  @param keys
   *  @param page
   * @param success
   * @param fail
   * @param isLoadingExplicit
   * @param errorHandler
   */
  listPurchaseMaterial(shopId,supplierId,keys,page,success, fail, isLoadingExplicit, errorHandler) {
    post.bind(this)(
      url.LIST_PURCHASE_MATERIAL_SHOP,
      {
        shopId: shopId,
        supplierId: supplierId,
        keys: keys,
        pageIndex: page.pagination,
        pageSize: page.size,
      },
      success,
      fail,
      isLoadingExplicit,
      errorHandler
    );
  },
  /**
   *  AJAX-分页获取要货货品列表
   *  @param shopId
   *  @param page
   *  @param keys
   * @param success
   * @param fail
   * @param isLoadingExplicit
   * @param errorHandler
   */
  listRequireMaterial(shopId,keys,page,success, fail, isLoadingExplicit, errorHandler) {
    post.bind(this)(
      url.LIST_REQUIRE_MATERIAL_SHOP,
      {
        shopId: shopId,
        keys: keys,
        pageIndex: page.pagination,
        pageSize: page.size,
      },
      success,
      fail,
      isLoadingExplicit,
      errorHandler
    );
  },

  /**
   *  AJAX-批量添加采购货品
   *  @param materialId
   *  @param supplierId
   *  @param shopIds
   * @param success
   * @param fail
   * @param isLoadingExplicit
   * @param errorHandler
   */
  batchAddPurchaseMaterial(materialId,supplierId,shopIds,success, fail, isLoadingExplicit, errorHandler) {
    post.bind(this)(
      url.BATCH_ADD_PURCHASE_MATERIAL,
      {
        materialId: materialId,
        supplierId: supplierId,
        shopIds: shopIds,
      },
      success,
      fail,
      isLoadingExplicit,
      errorHandler
    );
  },
  /**
   *  AJAX-门店-采购品
   * @param search
   * @param success
   * @param isLoadingExplicit
   * @param errorHandler
   */
  exportPurchaseMaterial(shopId, supplierId, name,success, isLoadingExplicit, errorHandler){
    postDownload.bind(this)(
      url.SHOP_EXPORT_PURCHASE_MATERIAL,
      {
        shopId: shopId,
        supplierId: supplierId,
        keys: name,
      },
      success,
      isLoadingExplicit,
      errorHandler
    );
  },
  /**
   *  AJAX-门店-要货品
   * @param search
   * @param success
   * @param isLoadingExplicit
   * @param errorHandler
   */
  exportRequireMaterial(shopId, name, success, isLoadingExplicit, errorHandler){
    postDownload.bind(this)(
      url.EXPORT_REQUIRE_MATERIAL,
      {
        shopId: shopId,
        keys: name,
      },
      success,
      isLoadingExplicit,
      errorHandler
    );
  },
}

export default shop;



// WEBPACK FOOTER //
// ./src/assets/ajax/ajax-shop.js